.container {
    display: flex;
    min-height: 60vh;
}

.imageBlock {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 40%;

    background: #f2f2f2;

    .thumbnail {
        height: 100%;
        min-height: 200px;
        max-height: 450px;
        max-width: 80%;

        box-shadow: 15px 20px 20px 0 rgba(34, 60, 80, 0.3);
    }

    .noPhoto {
        box-shadow: none;
    }
}

.infoBlock {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    width: 60%;
    padding: 50px 50px 0 50px;

    background: #fff;

    .categories {
        font-size: 20px;
    }

    .title {
        margin: 20px 0;
    }

    .authors {
        text-decoration: underline;
        margin-bottom: 20px;
    }

    .description {
        padding: 15px;
        line-height: 28px;

        font-size: 16px;
        font-weight: 500;
        border: 1px solid #c0c0c0;

        height: 450px;
        overflow: auto;
    }
}

@media all and (max-width: 992px) {
    .imageBlock {
        .thumbnail {
            height: 40%;
        }
    }

    .infoBlock {
        padding: 20px 20px 0 20px;
    }
}

@media all and (max-width: 768px) {
    section {
        width: 100vw;
    }

    .container {
        flex-wrap: wrap;
    }

    .imageBlock {
        width: 100%;
        min-height: 500px;

        background: unset;
    }

    .infoBlock {
        height: auto;
        width: 100%;

        .description {
            height: unset;
        }
    }

    .imageBlock .thumbnail {
        max-height: 70%;
        max-width: 100%;
        height: 500px;
    }
}